import { render, staticRenderFns } from "./DashboardPanelRanking.vue?vue&type=template&id=31d41024&scoped=true&"
import script from "./DashboardPanelRanking.vue?vue&type=script&lang=js&"
export * from "./DashboardPanelRanking.vue?vue&type=script&lang=js&"
import style1 from "./DashboardPanelRanking.vue?vue&type=style&index=1&id=31d41024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d41024",
  null
  
)

export default component.exports